import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function QueueSessionPopup({ show, handleClose, title, button, sideConvoList = [], apiUrl, queueId, loginUserID, apiToken, isStandalone = false  }) {
  const [sessionName, setSessionName] = useState(null);
  const [sessionType, setSessionType] = useState('topic');
  const [selectedSideConvo, setSelectedSideConvo] = useState('');
  const [error, setError] = useState('');
  const [buttonDisable, setButtonDisable] = useState(false);

  // console.log("QueueSessionPopup props:", { queueId });

  useEffect(() => {
    if (show) {
      setSessionName('');
      setSessionType('topic');
      setSelectedSideConvo('');
      setError('');
    } else {
      setSessionName('');
      setSessionType('topic');
      setSelectedSideConvo('');
    }
  }, [show]);

  const handleSubmit = () => {
      if (sessionType !== 'existing' && (!sessionName || !sessionName.trim())) {
    setError('Topic name is required');
    return;
  }
    if (sessionType === 'sub_topic' && !selectedSideConvo) {
      setError('Please select a Topic');
      return;
    }

    const payload = {
      session_name: sessionName,
      session_type: sessionType === 'existing' ? 'existing' : sessionType,
      parent_session_id: sessionType === 'sub_topic' ? selectedSideConvo : null,
      user_id: loginUserID,
      queue_request_id: queueId
    };
    setButtonDisable(true);
    console.log("Payload:", payload);

    fetch(`${apiUrl}/queue_session_create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiToken}`
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          handleClose();
        } else {
          setError(data.message || 'An error occurred');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        setError('An error occurred while creating the topic');
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header style={{ background: "#000", color: "#fff" }} closeButton closeVariant="white">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {sessionType !== 'existing' && (
          <Form.Group controlId="formSessionName">
            <Form.Label>Topic Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter topic name"
              value={sessionName}
              onChange={(e) => setSessionName(e.target.value)}
              isInvalid={!!error && !sessionName.trim()}
            />
            <Form.Control.Feedback type="invalid">
              {error && !sessionName.trim() ? error : ''}
            </Form.Control.Feedback>
          </Form.Group>
        )}
        <Form.Group className="mt-2">
          <Form.Label>Topic Type</Form.Label>
          <Form.Control
            as="select"
            value={sessionType}
            onChange={(e) => setSessionType(e.target.value)}
          >
            <option value="topic">Topic</option>
            <option value="sub_topic">Subtopic</option>
            {!isStandalone && <option value="existing">Existing topic</option>}
          </Form.Control>
        </Form.Group>
        {sessionType === 'sub_topic' && (
          <Form.Group className="mt-2">
            <Form.Label>Topics</Form.Label>
            <Form.Control
              as="select"
              value={selectedSideConvo}
              onChange={(e) => setSelectedSideConvo(e.target.value)}
              isInvalid={!!error && sessionType === 'sub_topic' && !selectedSideConvo}
            >
              <option value="">Select a Topic</option>
              {sideConvoList.map((convo) => (
                <option key={convo.id} value={convo.id}>{convo.name}</option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {error && sessionType === 'sub_topic' && !selectedSideConvo ? error : ''}
            </Form.Control.Feedback>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={buttonDisable} onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="dark" disabled={buttonDisable} onClick={handleSubmit}>
          {buttonDisable ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Creating...
            </>
          ) : (
            button
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default QueueSessionPopup;
